import CircularProgress from "@material-ui/core/CircularProgress";

import useStyles from "./loading.styles";

const Loading = (props: any) => {
  const classes = useStyles(props);

  const Progress = () => (
    <CircularProgress
      className={classes.loading}
      color="inherit"
      size={props.size || "2rem"}
      thickness={props.thickness ? parseFloat(props.thickness) : 2}
    />
  );

  if (props.on) {
    if (props.fullScreen) {
      return (
        <div className={classes.container}>
          <Progress />
        </div>
      );
    } else {
      return <Progress />;
    }
  } else {
    return null;
  }
};

export default Loading;
